import { render, staticRenderFns } from "./success-page.vue?vue&type=template&id=04766294&"
import script from "./success-page.vue?vue&type=script&lang=js&"
export * from "./success-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CImage: require('@chakra-ui/vue').CImage, CHeading: require('@chakra-ui/vue').CHeading, CText: require('@chakra-ui/vue').CText, CButton: require('@chakra-ui/vue').CButton})
